import { render, staticRenderFns } from "./TopNavBar.vue?vue&type=template&id=2f17db25&scoped=true&"
import script from "./TopNavBar.vue?vue&type=script&lang=js&"
export * from "./TopNavBar.vue?vue&type=script&lang=js&"
import style0 from "./TopNavBar.vue?vue&type=style&index=0&id=2f17db25&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2f17db25",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/codebuild/output/src2044461438/src/tacotrade-platform/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('2f17db25')) {
      api.createRecord('2f17db25', component.options)
    } else {
      api.reload('2f17db25', component.options)
    }
    module.hot.accept("./TopNavBar.vue?vue&type=template&id=2f17db25&scoped=true&", function () {
      api.rerender('2f17db25', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/TopNavBar.vue"
export default component.exports